import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "@/App";

const links = [
  ["Services", "#services"],
  ["Goals", "#goals"],
  ["Products", "#products"],
  ["Calculator", "#calculator"],
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const ink = scrolled ? "text-wealth" : "text-bone";

  return (
    <motion.header
      data-testid="main-navbar"
      initial={{ y: -90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-bone/85 backdrop-blur-xl border-b border-wealth/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 h-[92px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.2 })}
          className={`absolute left-1/2 -translate-x-1/2 text-center ${ink} transition-colors duration-500`}
        >
          <span className="font-display text-2xl font-semibold tracking-tight leading-none">
            Madhura Gokhale
          </span>
          <span className="flex items-center mt-1">
            <img
              src="https://i.wlycdn.com/wealthy-home-page/wealthy-new-purple-logo.svg"
              alt="Wealthy"
              className={`h-8 w-auto ${scrolled ? "" : "brightness-0 invert"}`}
            />
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map(([label, href]) => (
            <button
              key={href}
              data-testid={`nav-link-${label.toLowerCase()}`}
              onClick={() => scrollToId(href)}
              className={`text-xs font-semibold uppercase tracking-[0.22em] ${ink} opacity-70 hover:opacity-100 transition-opacity duration-300`}
            >
              {label}
            </button>
          ))}
        </nav>

      </div>
    </motion.header>
  );
};
